// 同步改变state
import { saveUserInfo } from "@/utils/api"

const mainMutation = {
	// 更新用户信息
	updateUserInfo(state, userInfo) {
		state.userInfo = Object.assign({}, state.userInfo, userInfo);

		// 更新本地localstorage
		saveUserInfo(state.userInfo);
	},

	// 更新用户菜单权限
	updateUserMenu(state, userMenu){
		state.userMenu = userMenu;
	},

	// 更新消息中心未读消息数量
	updateNoReadNums(state, num){
		state.noReadNums = num;
	},

}
export default mainMutation
